import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import SignaturePad from 'react-signature-canvas'

import styles from './css/styles.module.css'

class RadioButtonGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
  
    
    handleChange = e => {
        const { name, value } = e.target;
       
        this.setState({
          [name]: value
        });
        let choices = this.props && this.props.choices
        var asnswer_id = -1;
        choices.map((ans, i)=>{
            if(ans['isAnswere'] && ans['isAnswere'] == true ){ asnswer_id = i}
            } 
        )
        var isCorrect = (asnswer_id != -1 && asnswer_id == e.target.id)? true : false;
        this.props && this.props.checkAnswer(name, value, isCorrect)

    };


    render () {
        let choices = this.props && this.props.choices
        let index = this.props && this.props.index
        
        return (
        <>
            {choices && choices.map((ans, i)=>
            <font color="#202020" size="2">
                &nbsp;&nbsp;&nbsp;
                <span  key={i+900}>{i + 1}.
                    <input 
                            id={i}
                            type="radio" 
                            value={ans['answer']} 
                            name={index} 
                            onChange={this.handleChange}
                    />
                {ans['answer']}<br/></span>
            </font>
            )}
        </>
        )
    }
}

export default RadioButtonGroup